const fiscalNone = {
  invoiceId: null,
  invoiceNumber: '',
  invoiceType: 'none',
  accessKey: '',
  installmentGroupId: null,
  installmentNumber: 1,
  installmentTotal: 1,
  totalAmount: null,
};

export const accountsPayable = [
  {
    id: 'ap_001',
    organizationId: 'org_3la_labs',
    description: 'Hospedagem VPS',
    supplierId: 'sup_hostinger',
    supplierName: 'Hostinger',
    category: 'Infraestrutura',
    costCenter: 'Tecnologia',
    issueDate: '01/09/2026',
    dueDate: '05/09/2026',
    amount: 89.9,
    paymentMethod: 'Cartão de crédito',
    bankAccountId: 'bank_nubank',
    bankAccountName: 'Nubank PJ',
    status: 'A vencer',
    notes: 'Plano Cloud VPS mensal',
    recurring: true,
    ...fiscalNone,
    totalAmount: 89.9,
  },
  {
    id: 'ap_002',
    organizationId: 'org_3la_labs',
    description: 'Google Workspace',
    supplierId: 'sup_google',
    supplierName: 'Google',
    category: 'Software',
    costCenter: 'Administrativo',
    issueDate: '01/09/2026',
    dueDate: '10/09/2026',
    amount: 72,
    paymentMethod: 'Cartão de crédito',
    bankAccountId: 'bank_nubank',
    bankAccountName: 'Nubank PJ',
    status: 'A vencer',
    notes: '5 licenças Business Starter',
    recurring: true,
    ...fiscalNone,
    totalAmount: 72,
  },
  {
    id: 'ap_003',
    organizationId: 'org_3la_labs',
    description: 'Honorários contábeis',
    supplierId: 'sup_contabilidade',
    supplierName: 'Contabilidade Exata',
    category: 'Administrativo',
    costCenter: 'Administrativo',
    issueDate: '01/09/2026',
    dueDate: '15/09/2026',
    amount: 450,
    paymentMethod: 'PIX',
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'A vencer',
    notes: '',
    recurring: true,
    ...fiscalNone,
    totalAmount: 450,
  },
  {
    id: 'ap_004',
    organizationId: 'org_3la_labs',
    description: 'Microsoft 365 Business',
    supplierId: 'sup_microsoft',
    supplierName: 'Microsoft 365',
    category: 'Software',
    costCenter: 'Tecnologia',
    issueDate: '28/08/2026',
    dueDate: '03/09/2026',
    amount: 165,
    paymentMethod: 'Cartão de crédito',
    bankAccountId: 'bank_nubank',
    bankAccountName: 'Nubank PJ',
    status: 'Vencido',
    notes: '',
    recurring: true,
    ...fiscalNone,
    totalAmount: 165,
  },
  {
    id: 'ap_005',
    organizationId: 'org_3la_labs',
    description: 'Infraestrutura AWS',
    supplierId: 'sup_aws',
    supplierName: 'AWS',
    category: 'Infraestrutura',
    costCenter: 'Tecnologia',
    issueDate: '01/09/2026',
    dueDate: '20/09/2026',
    amount: 1280.3,
    paymentMethod: 'Débito automático',
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'Pendente',
    notes: 'Consumo estimado setembro',
    recurring: true,
    ...fiscalNone,
    totalAmount: 1280.3,
  },
  {
    id: 'ap_006',
    organizationId: 'org_3la_labs',
    description: 'Campanha Google Ads',
    supplierId: 'sup_google',
    supplierName: 'Google',
    category: 'Marketing',
    costCenter: 'Marketing',
    issueDate: '15/08/2026',
    dueDate: '25/08/2026',
    amount: 1200,
    paymentMethod: 'PIX',
    bankAccountId: 'bank_mp',
    bankAccountName: 'Mercado Pago',
    status: 'Pago',
    notes: 'Campanha Q3',
    recurring: false,
    ...fiscalNone,
    totalAmount: 1200,
  },
  {
    id: 'ap_007',
    organizationId: 'org_3la_labs',
    description: 'Renovação domínio .com.br',
    supplierId: 'sup_hostinger',
    supplierName: 'Hostinger',
    category: 'Infraestrutura',
    costCenter: 'Tecnologia',
    issueDate: '20/08/2026',
    dueDate: '12/09/2026',
    amount: 49.9,
    paymentMethod: 'PIX',
    bankAccountId: 'bank_nubank',
    bankAccountName: 'Nubank PJ',
    status: 'Agendado',
    notes: '3lalabs.com.br',
    recurring: false,
    ...fiscalNone,
    totalAmount: 49.9,
  },
  {
    id: 'ap_nfe_001',
    organizationId: 'org_3la_labs',
    description: 'NFe 000088 — Compra para comercialização',
    supplierId: 'sup_microsoft',
    supplierName: 'Microsoft 365',
    category: 'Software',
    costCenter: 'Tecnologia',
    issueDate: '28/08/2026',
    dueDate: '10/09/2026',
    amount: 1100,
    paymentMethod: 'Boleto',
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'A vencer',
    notes: 'Duplicata 001 — importada',
    recurring: false,
    invoiceId: 'nfe_imp_088',
    invoiceNumber: '000088',
    invoiceType: 'nfe',
    accessKey: '35260899887766000155550020000000881000000885',
    installmentGroupId: 'ig_nfe_imp_088',
    installmentNumber: 1,
    installmentTotal: 3,
    totalAmount: 3300,
  },
  {
    id: 'ap_nfe_002',
    organizationId: 'org_3la_labs',
    description: 'NFe 000088 — Compra para comercialização',
    supplierId: 'sup_microsoft',
    supplierName: 'Microsoft 365',
    category: 'Software',
    costCenter: 'Tecnologia',
    issueDate: '28/08/2026',
    dueDate: '10/10/2026',
    amount: 1100,
    paymentMethod: 'Boleto',
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'Agendado',
    notes: 'Duplicata 002 — importada',
    recurring: false,
    invoiceId: 'nfe_imp_088',
    invoiceNumber: '000088',
    invoiceType: 'nfe',
    accessKey: '35260899887766000155550020000000881000000885',
    installmentGroupId: 'ig_nfe_imp_088',
    installmentNumber: 2,
    installmentTotal: 3,
    totalAmount: 3300,
  },
  {
    id: 'ap_nfe_003',
    organizationId: 'org_3la_labs',
    description: 'NFe 000088 — Compra para comercialização',
    supplierId: 'sup_microsoft',
    supplierName: 'Microsoft 365',
    category: 'Software',
    costCenter: 'Tecnologia',
    issueDate: '28/08/2026',
    dueDate: '10/11/2026',
    amount: 1100,
    paymentMethod: 'Boleto',
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'Agendado',
    notes: 'Duplicata 003 — importada',
    recurring: false,
    invoiceId: 'nfe_imp_088',
    invoiceNumber: '000088',
    invoiceType: 'nfe',
    accessKey: '35260899887766000155550020000000881000000885',
    installmentGroupId: 'ig_nfe_imp_088',
    installmentNumber: 3,
    installmentTotal: 3,
    totalAmount: 3300,
  },
];
